import { render, staticRenderFns } from "./changelog-collaborator.vue?vue&type=template&id=4bd6de19"
import script from "./changelog-collaborator.vue?vue&type=script&lang=js"
export * from "./changelog-collaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports